export enum TransactionStatesEnum {
    NONE = 0,
    CANCELED = 1,
    // try to not use 2, old TO_FUTURE
    TO_NEW_TICKET = 3,
    TO_FUTURE = 5,
    TO_FUTURE_READY = 6,
    HELD_DISPUTED = 9,
    HELD = 10,
    WAITING_PAYMENT = 11,
    CREDITED_PAYMENT = 12,
    /** @deprecated */
    ID_REQUIRED = 13,
    /** @deprecated */
    FORM_REQUIRED = 14,
    /** @deprecated */
    FACEBOOK_REQUIRED = 15,
    VALIDATION_REQUIRED = 16,
    SCAMMED = 20,
    PRE_APPROVED_SENT = 21,
    SENT = 22,
    MEDIATION = 23
}
